






function getPageType() {
  let path = window.initContext?.context?.document?.location?.pathname || window.location.pathname;

  if (typeof path !== 'string') return 'other';

  if (path === '/') { return 'home'; }
  else if (path.includes('/collection')) { return 'listing'; }
  else if (path.includes('/pages')) { return 'editorial'; }
  else if (path.includes('/product')) { return 'product'; }
  else if (path.includes('/cart')) { return 'cart'; }
  else if (path.includes('thank_you') || path.includes('thank-you')) { return 'purchase'; }  
  else if (path.includes('/checkout')) { return 'checkout'; }
  else { return 'other'; }
}

function getLanguageAndCountry() {
  const fromShop = {
    language: window.shopLocale?.language || window.Shopify?.locale,
    country: window.shopLocale?.country || window.Shopify?.country
  };

  if (fromShop.language && fromShop.country) return fromShop;

  const browserLocale = navigator.language || 'en-US';
  const [lang, ctry] = browserLocale.split('-');

  return {
    language: lang || '',
    country: ctry || ''
  };
}

const { language, country } = getLanguageAndCountry();
window.dataLayer = window.dataLayer || [];

window.dataLayer.push({
  visitor_logged_in: "no",
  visitor_measures: "",
  visitor_totalTransactions: 0,
  visitor_lifeTimeValue: 0,
  daysFromLastTransaction: 0,
  visitor_email: "",
  page_type: getPageType(),
  page_country: country,
  page_language: language,
  page_currency: ""
});